/* Mesmo registro do gatsby-ssr.js. Os DOIS precisam importar: o SSR para gerar
   o HTML das dobras, o browser para o editor visual do Builder encontrar os
   componentes na lista. */
require('./src/builder-registry')

const { capturarUtm } = require('./src/lib/utm')

/**
 * Captura os UTMs no primeiro carregamento e a cada troca de rota.
 *
 * `onRouteUpdate` e não só `onClientEntry`: a landing é uma página, mas o
 * Builder pode criar outras (obrigado, /programacao) e a navegação entre elas é
 * client-side — sem passar de novo por aqui, os parâmetros da URL de entrada se
 * perderiam na primeira troca.
 */
exports.onClientEntry = () => {
  capturarUtm()
}

exports.onRouteUpdate = () => {
  capturarUtm()
}
